import { Card } from "react-bootstrap"
import { useEffect } from "react"
import i18n from "../i18n"
import EmailStepComponent from '../components/loginSteps/emailStep.component'
import PasswordStepComponent from '../components/loginSteps/passwordStep.component'
import MfaStepComponent from '../components/loginSteps/mfaStep.component'
import useDocument from '../hooks/useDocument.hooks'
import { useAuth } from "../context/auth.context";
import { LoginMode } from "../enums/auth.enum";
import LoadingComponent from "../components/loading.component";
import useCustomCookies from "../hooks/useCustomCookies.hooks";
import {updateSettings} from "../actions/auth.action";

function LoginPage() {

    const { t } = i18n;
    const {settings, dispatch} = useAuth();
    const {deleteAuthCookies} = useCustomCookies();

    useDocument({ title: t('_page_title.login') })

    useEffect(() => {
        deleteAuthCookies();

        try {
            sessionStorage.clear();
        } catch {}

        dispatch(updateSettings({
            ...settings,
            error: '',
            attemptsLeft: -1,
            emailVerified: false,
            emailConfirmed: false,
            passwordConfirmed: false,
            globalLoadingState: false,
            loginMode: LoginMode.BASIC,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Card.Body>
                <Card.Title className="text-start"><h1>{t('_sign_in.title')}</h1></Card.Title>
                <Card.Text className="text-start">{t('_sign_in.description')}</Card.Text>

                {!settings.emailConfirmed && <EmailStepComponent />}
                {settings.emailConfirmed && !settings.passwordConfirmed && <><EmailStepComponent /> <PasswordStepComponent /></>}
                {settings.emailConfirmed && settings.passwordConfirmed && !settings.globalLoadingState && settings.loginMode === LoginMode.MFA && <MfaStepComponent />}
                {settings.emailConfirmed && settings.passwordConfirmed && settings.globalLoadingState && <LoadingComponent />}

            </Card.Body>
        </>
    )
}

export default LoginPage